import React from 'react';
import DataGrid from "../../form/SelectorGrid/DataGrid";
import {remoteOptionFormatter} from "../../../utils/formatters";
import DefaultFilter from "../../form/SelectorGrid/DataGrids/Table/DefaultFilter";
import TextInput from "../../form/TextInput";
import {saveChangesEvent} from "../../../utils/events";
import config from "../../../config/config";
import Select from "../../form/Select";

class StateFilter extends DefaultFilter {
    render() {
        let filter = this.props.filter || {field: this.props.filterField || this.props.field, value: null, operator: this.props.filterOperator || "="};
        return (
            <Select
                storeType="local"
                label={false}
                value={this.state.value}
                focus={true}
                optionname="ShippingTourState"
                objectValue={false}
                isClearable={true}
                saveChanges={saveChangesEvent((event) => {
                    let value = event.value;
                    this.setState({value});
                    if(value !== null && value !== undefined) {
                        this.props.setFilter({...filter, value: value});
                    } else {
                        this.props.setFilter(undefined);
                    }
                })}
            />
        );
    }
}

class ShippingTourList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, pageSize} = this.props;
        const props = {view, componentConfig, filter, isLoading, selection, pageSize: pageSize ?? 5};
        return (
            <DataGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "ShippingTourList"}
                {...props}
                rowClassName={({item}) => {
                    return {
                        "warning": parseInt(item.state || "0") === 100,
                        "success": parseInt(item.state || "0") === 200
                    }
                }}
                fields={{
                    "id": {
                        props: {
                            header: 'Kód',
                            width: 1,
                            sortable,
                            filterable
                        }
                    },
                    "name": {
                        props: {
                            header: 'Név',
                            width: 2,
                            sortable,
                            filterable
                        }
                    },
                    "shipping_date": {
                        props: {
                            header: 'Szállitás ideje',
                            order: "DESC",
                            width: 2,
                            sortable,
                            filterable
                        }
                    },
                    "state": {
                        props: {
                            header: 'Státusz',
                            order: "ASC",
                            width: 2,
                            sortable,
                            filterable: StateFilter,
                            formatter: ({row}) => {
                                return remoteOptionFormatter("ShippingTourState")(row.state);
                            }
                        }
                    }
                }}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default ShippingTourList;
